package team.platforma.chat_data.di

import org.koin.core.module.Module
import org.koin.dsl.bind
import org.koin.dsl.module
import team.platforma.chat_data.database.chats.ChatsTable
import team.platforma.chat_data.database.chats.ChatsTableImpl
import team.platforma.chat_data.database.draft.DraftTable
import team.platforma.chat_data.database.draft.DraftTableImpl
import team.platforma.chat_data.database.messages.MokMessagesTable
import team.platforma.chat_data.database.messages.MokMessagesTableImpl
import team.platforma.chat_data.repository.chats.ChatsRepository
import team.platforma.chat_data.repository.chats.ChatsRepositoryImpl
import team.platforma.chat_data.repository.draft.DraftRepository
import team.platforma.chat_data.repository.draft.DraftRepositoryImpl
import team.platforma.chat_data.repository.messages.MokMessagesRepository
import team.platforma.chat_data.repository.messages.MokMessagesRepositoryImpl

val chatDataModule: Module = module {
    single {
        DraftTableImpl(chatDatabase = get())
    }.bind<DraftTable>()
    single {
        DraftRepositoryImpl(
            draftTable = get()
        )
    }.bind<DraftRepository>()

    single {
        MokMessagesTableImpl(
            chatDatabase = get()
        )
    }.bind<MokMessagesTable>()

    single {
        ChatsTableImpl(chatDatabase = get())
    }.bind<ChatsTable>()
    single {
        ChatsRepositoryImpl(
            chatsTable = get()
        )
    }.bind<ChatsRepository>()

    single {
        MokMessagesRepositoryImpl(
            mokMessagesTable = get(),
            client = get(),
            chatsRepository = get()
        )
    }.bind<MokMessagesRepository>()



}